export const createSearchPath = ({ orgId, streamId, channelId }) => {
  if (orgId && streamId && channelId) {
    return `/${orgId}/${streamId}/${channelId}/items`;
  }

  if (orgId && streamId) {
    return `/${orgId}/${streamId}`;
  }

  if (orgId) {
    return `/${orgId}`;
  }

  return '';
};
